export interface CornerRadius {
  tl: number;
  tr: number;
  br: number;
  bl: number;
}

export function roundedRectPath(x: number, y: number, w: number, h: number, r: CornerRadius): Path2D {
  const path = new Path2D();
  const { tl, tr, br, bl } = r;
  path.moveTo(x + tl, y);
  path.lineTo(x + w - tr, y);
  path.arcTo(x + w, y, x + w, y + tr, tr);
  path.lineTo(x + w, y + h - br);
  path.arcTo(x + w, y + h, x + w - br, y + h, br);
  path.lineTo(x + bl, y + h);
  path.arcTo(x, y + h, x, y + h - bl, bl);
  path.lineTo(x, y + tl);
  path.arcTo(x, y, x + tl, y, tl);
  path.closePath();
  return path;
}
